import MuiAvatar from '@mui/material/Avatar'

import { Protocol } from '#/components/FormatCell/Types/AvatarLink'
import { Icon } from '#/components/Icon'
import Colors from '#/styles/Colors'

type AvatarProtocolProps = {
  protocol: Protocol
}

function AvatarProtocol({ protocol }: AvatarProtocolProps) {
  const status = protocol?.status?.status
  const colors = Colors.status?.[status!]

  return (
    <MuiAvatar style={{ backgroundColor: colors?.backgroundColor }}>
      <Icon size="large" name="health-protocol" sx={{ color: colors?.color, fontSize: '24px' }} />
    </MuiAvatar>
  )
}

export { AvatarProtocol }
